module.exports = __webpack_public_path__ + "static/media/push.24cb4c94.svg";